import { inject, Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";

interface IconPaths {
    [key: string]: string;
}

@Injectable({ providedIn: "root" })
export class IconService {
    private iconPaths: IconPaths = {
        search: "assets/icons/search.svg",
        wishlist: "assets/icons/wishlist.svg",
        cart: "assets/icons/cart.svg",
        user: "assets/icons/user.svg",
        box_user: "assets/icons/box_user.svg",
        keyboard_arrow_down: "assets/icons/keyboard_arrow_down.svg",
        home: "assets/icons/home.svg",
        briefcase: "assets/icons/briefcase.svg",
        location: "assets/icons/location.svg",
        right_arrow_alt: "assets/icons/right_arrow_alt.svg",
        check: "assets/icons/check.svg",
        shield_half: "assets/icons/shield_half.svg",
        notification: "assets/icons/notification.svg",
        order: "assets/icons/order.svg",
        contact: "assets/icons/contact.svg",
        logout: "assets/icons/logout.svg",
        backarrow: "assets/icons/backarrow.svg",
        forwardarrow: "assets/icons/forwardarrow.svg",
        giftbox: "assets/icons/giftbox.svg",
        tag: "assets/icons/tag.svg",
        delivery: "assets/icons/delivery.svg",
        newarrival: "assets/icons/newarrival.svg",
        fullstar: "assets/icons/fullstar.svg",
        halfstar: "assets/icons/halfstar.svg",
        rightarrow: "assets/icons/rightarrow.svg",
        plus: "assets/icons/plus.svg",
        minus: "assets/icons/minus.svg",
        activewishlist: "assets/icons/activewishlist.svg",
        age: "assets/icons/age.svg",
        safematerial: "assets/icons/safematerial.svg",
        bulb: "assets/icons/bulb.svg",
        color: "assets/icons/color.svg",
        tick: "assets/icons/tick.svg",
        ig: "assets/icons/ig.svg",
        fb: "assets/icons/fb.svg",
        utube: "assets/icons/utube.svg",
        pin: "assets/icons/pin.svg",
        paypal: "assets/icons/paypal.svg",
        visa: "assets/icons/visa.svg",
        mastercard: "assets/icons/mastercard.svg",
        arrowleft: "assets/icons/arrowleft.svg",
        save: "assets/icons/save.svg",
        greaterthan: "assets/icons/greaterthan.svg",
        freedelivery: "assets/icons/freedelivery.svg",
        return: "assets/icons/return.svg",
        date: "assets/icons/date.svg",
        delete: "assets/icons/delete.svg",
        empty: "assets/icons/empty.svg",
        noproduct: "assets/icons/noproduct.svg",
        loginBox: "/assets/icons/box.svg",
        shield: "/assets/icons/shield.svg",
        lock: "/assets/icons/lock.svg",
        pencil: "/assets/icons/edit-pencil.svg",
        phone: "/assets/icons/phone.svg",
        email: "/assets/icons/email.svg",
        clock: "/assets/icons/clock.svg",
        twitter: "/assets/icons/twitter.svg",
        send: "/assets/icons/send.svg",
        minpurchase: "assets/icons/minpurchase.svg",
        cod: "assets/icons/cod.svg",
        onlinepay: "assets/icons/onlinepay.svg",
    };

    iconRegistry = inject(MatIconRegistry);
    domSanitizer = inject(DomSanitizer);

    constructor() {}

    public registerIcons(): void {
        Object.keys(this.iconPaths).forEach((key) => {
            const iconPath = this.iconPaths[key];
            this.iconRegistry.addSvgIcon(key, this.domSanitizer.bypassSecurityTrustResourceUrl(iconPath));
        });
    }
}
